/*
 * @Author: pengyong
 * @Date: 2020-11-11 22:20:50
 * @LastEditors: awu
 * @LastEditTime: 2020-12-08 22:51:54
 * @Description: 会议厅接口定义
 * @FilePath: /exhibit/src/api/conference.js
 */
import axios from "@/utils/axios.js";
import { BASE_URL } from "./config";

// 联系我们
export function schedule(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/web/schedule`, params);
}
// https://gatewazy.yunzhizhan.cn:8743/exhibition/api/v1/web/schedule?hall_id=1 （1.论坛、2.路演. 3首页）

// 获取嘉宾信息
export function getGuestInfo(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/web/schedule/guest`, params);
}



// WEBPACK FOOTER //
// ./src/api/conference.js